export default __webpack_public_path__ + "static/media/punjab.40b4b738.jpg";